import { AppRoutes } from './common/constants';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { JSX } from 'react';
import BuyAndSellPage from './fna/buyAndSellPage';
import ClientsPage from './clients/clientsPage';
import DashboardPage from './dashboard/dashboardPage';
import EditFnaPage from './fna/editFnaPage';
import EditLegalEntityPage from './clients/legalEntityPage/editLegalEntityPage';
import EditNaturalPersonPage from './clients/naturalPersonPage/editNaturalPersonPage';
import EditReport from './reports/editReport';
import ErrorPage from './common/components/errorPage';
import FnaBuyAndSellNeedPage from './fna/buyAndSellPage/fnaBuyAndSellNeedPage';
import FnaKeypersonNeedPage from './fna/fnaKeypersonPage/fnaKeypersonNeedPage';
import FnaKeypersonPage from './fna/fnaKeypersonPage';
import FnaQuotesPage from './fna/fnaQuotesPage';
import FNAsPage from './fna/FNAsPage';
import FnaSuretyshipNeedPage from './fna/fnaSuretyshipPage/fnaSuretyshipNeedPage';
import FnaSuretyshipPage from './fna/fnaSuretyshipPage';
import IdleTimeoutDialog from './common/components/idleTimeoutDialog';
import LegalEntityPage from './clients/legalEntityPage';
import NaturalPersonPage from './clients/naturalPersonPage';
import PrivateRoute from './common/components/privateRoute';
import QuotesPage from './quotes/quotesPage';
import ReportResults from './reports/reportResults';
import ReportsPage from './reports/reportsPage';

const privateRouter = createBrowserRouter([
  {
    path: AppRoutes.Dashboard,
    element: <PrivateRoute element={<DashboardPage />} />,
  },
  {
    path: AppRoutes.Clients,
    element: <PrivateRoute element={<ClientsPage />} />,
  },
  {
    path: `${AppRoutes.NaturalPersons}/:id`,
    element: <PrivateRoute element={<NaturalPersonPage />} />,
  },
  {
    path: `${AppRoutes.NaturalPersons}/:id/edit`,
    element: <PrivateRoute element={<EditNaturalPersonPage />} />,
  },
  {
    path: `${AppRoutes.LegalEntities}/:id`,
    element: <PrivateRoute element={<LegalEntityPage />} />,
  },
  {
    path: `${AppRoutes.LegalEntities}/:id/edit`,
    element: <PrivateRoute element={<EditLegalEntityPage />} />,
  },
  {
    path: AppRoutes.FNAs,
    element: <PrivateRoute element={<FNAsPage />} />,
  },
  {
    path: `${AppRoutes.FNAs}/:id`,
    element: <PrivateRoute element={<EditFnaPage />} />,
  },
  {
    path: `${AppRoutes.FNAs}/:id/quotes`,
    element: <PrivateRoute element={<FnaQuotesPage />} />,
  },
  {
    path: `${AppRoutes.FNAs}/:id/suretyship`,
    element: <PrivateRoute element={<FnaSuretyshipPage />} />,
  },
  {
    path: `${AppRoutes.FNAs}/:id/suretyship/needs`,
    element: <PrivateRoute element={<FnaSuretyshipNeedPage />} />,
  },
  {
    path: `${AppRoutes.FNAs}/:id/keyperson`,
    element: <PrivateRoute element={<FnaKeypersonPage />} />,
  },
  {
    path: `${AppRoutes.FNAs}/:id/keyperson/needs`,
    element: <PrivateRoute element={<FnaKeypersonNeedPage />} />,
  },
  {
    path: `${AppRoutes.FNAs}/:id/buy-and-sell`,
    element: <PrivateRoute element={<BuyAndSellPage />} />,
  },
  {
    path: `${AppRoutes.FNAs}/:id/buy-and-sell/needs`,
    element: <PrivateRoute element={<FnaBuyAndSellNeedPage />} />,
  },
  {
    path: AppRoutes.Quotes,
    element: <PrivateRoute element={<QuotesPage />} />,
  },
  {
    path: AppRoutes.Reports,
    element: <PrivateRoute element={<ReportsPage />} />,
  },
  {
    path: `${AppRoutes.Reports}/:id`,
    element: <PrivateRoute element={<EditReport />} />,
  },
  {
    path: `${AppRoutes.Reports}/:id/results`,
    element: <PrivateRoute element={<ReportResults />} />,
  },
  {
    path: AppRoutes.ErrorPage,
    element: <ErrorPage />,
  },
]);

const App = (): JSX.Element => {
  return (
    <>
      <IdleTimeoutDialog />
      <RouterProvider router={privateRouter} />
    </>
  );
};

export default App;
